import { c as _c } from "react/compiler-runtime";
/*
TODO: Update this component to use your client-side framework's link
component. We've provided examples of how to do this for Next.js,
Remix, and Inertia.js in the Catalyst documentation:

https://catalyst.tailwindui.com/docs#client-side-router-integration
*/

import { DataInteractive as HeadlessDataInteractive } from '@headlessui/react';
import NextLink, { type LinkProps } from 'next/link';
import { useParams } from 'next/navigation';
import React from 'react';
export const Link = React.forwardRef(function Link(props, ref) {
  const $ = _c(4);
  const params = useParams();
  const lng = params?.lng;
  let href = props.href;
  if (lng && typeof href === "string" && href.startsWith("/") && !href.startsWith("//")) {
    const pathname = href.split(/[?#]/, 1)[0];
    const isAlreadyPrefixed = pathname === `/${lng}` || pathname?.startsWith(`/${lng}/`);
    if (!isAlreadyPrefixed) {
      href = `/${lng}${href}`;
    }
  }
  let t0;
  if ($[0] !== href || $[1] !== props || $[2] !== ref) {
    t0 = <HeadlessDataInteractive><NextLink {...props} href={href} ref={ref} /></HeadlessDataInteractive>;
    $[0] = href;
    $[1] = props;
    $[2] = ref;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  return t0;
});